export default {
    title: 'Plugins',
    'create-button': 'Create Plugin',
    'remove-dialog': {
        title: 'Remove plugin?',
        description: 'Are you sure you want to remove plugin: {plugin}',
    },
    fields: {
        name: 'Name',
        description: 'Description',
        input: 'Plugin test input JSON',
    },
    'has-changes': 'There are unsaved changes in the plugin. Are you sure you want to exit?',
    search: 'Search by name',
    import: {
        button: 'Import from JSON',
        title: 'Import Plugins from JSON',
        paste: 'Paste JSON here...',
    },
    export: 'Export as JSON',
}
